module.exports = __webpack_public_path__ + "static/35-thumb-ddbbff68e954cbbbd5d043001cfb5cf9.jpg";